<template lang="pug">
include ../pug/svg
section#assignment(v-if="userOrganisation.role.slug==='mentor'")
	div#ctrl
		div
			Search(v-model:search="search")
			Filter(v-if="assignFilters.length" id="assignFilter" label="Assignment Mode" title="Assignment Mode" :options="assignFilters" v-model:selected="assignFilter" :clear="false")
			Filter(v-if="groupFilters.length" id="groupFilter" :label="terminology('user','group','singular')" :title="terminology('user','group','singular')" :options="groupFilters" v-model:selected="groupFilter")
	div.wrapper
		h6
			button.but.circ.dblfwdarr.text(type="button" @click="assignUsers(unassignedUsers)" :disabled="!unassignedUsers.length")
				span Assign All
				+svg(svg-filename="iconDoubleArrow" aria-hidden="true" alt="Assign all icon")
			span Unassigned ({{unassignedUsers.length}})
		h6
			span Assigned ({{assignedUsers.length}})
			button.but.circ.dblbckarr.text.flip(type="button" @click="unassignUsers(assignedUsers)" :disabled="!assignedUsers.length")
				span Unassign All
				+svg(svg-filename="iconDoubleArrow" aria-hidden="true" alt="Unassign all icon")
	div.wrapper
		div.listbg
			ul.list.unassigned
				li(v-for="user in unassignedUsers")
					picture.user(v-if="user.profileUrl" :class="{online:user.online}")
						img(:src="user.profileUrl" width="40" height="40" :alt="user.fullName")
					span.user(v-else :class="{online:user.online}") {{user.initials}}
					div.hgroup
						h2 {{user.fullName}}
						h3 {{terminology('user', user.userOrganisations[0].role.slug,'singular')}}
							span.email {{user.email}}
					button.but.circ.fwdarr(type="button" @click="assignUsers(user)")
						span Assign User
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Assign icon")
		div.listbg
			ul.list.assigned
				li(v-for="user in assignedUsers")
					picture.user(v-if="user.profileUrl" :class="{online:user.online}")
						img(:src="user.profileUrl" width="40" height="40" :alt="user.fullName")
					span.user(v-else :class="{online:user.online}") {{user.initials}}
					div.hgroup
						h2 {{user.fullName}}
						h3 {{terminology('user', user.userOrganisations[0].role.slug,'singular')}}
							span.email {{user.email}}
					button.but.circ.bckarr(type="button" @click="unassignUsers(user)")
						span Unassign User
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Unassign icon")
</template>
<script>
import Search from '../components/Search';
import Filter from '../components/Filter';
	
export default {
	name: 'ManagePeopleUserAssignment',
	props: ['cancelled'],
	emits: ['storeUpdated'],
	components: {
		Search,
		Filter,
	},
	data() {		
		return {
			userId: parseInt(this.$route.params.userId),
			search: null,
			assignFilters: [
				{
					option: 'Assign',
					value: 'assign',
				},
				{
					option: 'Reassign ',
					value: 'reassign',
				},
			],
			assignFilter: null,
			groupFilter: null,
		};
	},
	beforeMount() {
		// access check
		const org = this.$store.state.gui.organisation;
		const authUser = this.$store.state.auth.user;
		
		if (!org.assignmentIndividual || authUser.userOrganisations[0].role.seniority > 50) {
			// prevent access if learner or mentor assignment not active
			this.$router.push({ name: 'ManagePeople' });
		}
	},
	mounted() {
		this.assignFilter = this.assignFilters[0]; // default
		
		const header = (this.manageSelf) ? {
			title: 'Account Assignment ('+this.user.email+')',
			backRoute: {
				text: 'Dashboard',
				name: 'Dashboard',
			},
		} : {
			title: this.terminology('user','learner','singular') + ' Assignment',
			backRoute: {
				text: this.terminology('user','user','plural'),
				name: 'ManagePeople',
			},
		};
		
		this.$store.dispatch('gui/setHeader', header);
	},
/*	watch: {
		cancelled: {
			// parent triggered cancel
			handler(val) {
				if (!val) { // store reset complete
				}
			},
			deep: true,
		},
	},*/
	computed: {
		manageSelf() {
			return (this.$route.name === 'ManageAccountUserAssignment');
		},
		authUser() {
			return this.$store.state.auth.user;
		},
		user() {
			return (this.manageSelf) ? this.authUser : this.$store.getters['users/getUser'](this.userId);
		},
		userOrganisation() {
			return this.user.userOrganisations[0];
		},
		userOrganisationId() {
			return this.userOrganisation.id;
		},
		users() {
			return [...this.$store.state.users.users].sort((a, b) => a.fullName.localeCompare(b.fullName));
		},
		filteredUsers() {
			// remove non-student and archived users
			let activeUsers = this.users.filter(u => u.userOrganisations[0].role.slug === 'learner' && u.userOrganisations[0].status !== 'archived');
			
			// apply user group filter
			const groupSelected = this.groupFilter?.value || null;
			activeUsers = (groupSelected) ? activeUsers.filter(u => u.userOrganisations[0].userOrganisationGroups.map(g => g.organisationGroupId).includes(groupSelected)) : activeUsers;
			
			// apply serch term filter
			return (this.search) ? activeUsers.filter(u => u.fullName.toLowerCase().includes(this.search.toLowerCase())) : activeUsers;
		},
		unassignedUsers() {
			const assignFilter = this.assignFilter?.value || null;
			
			if (assignFilter === 'reassign') {
				return this.filteredUsers.filter(u => u.userOrganisations[0].userOrganisationId !== null && u.userOrganisations[0].userOrganisationId !== this.userOrganisationId);
			
			} else { // assign (unassigned)
				return this.filteredUsers.filter(u => u.userOrganisations[0].userOrganisationId === null);
			}
		},
		assignedUsers() {
			return this.filteredUsers.filter(u => u.userOrganisations[0].userOrganisationId === this.userOrganisationId);
		},
		groupFilters() {
			const groups = this.$store.state.gui.organisation.organisationGroups;
			// map value/option pairs to group data
			return groups.map(g => {
				return { value: g.id, option: g.name };
			});
		},
	},
	methods: {
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		assignUsers(user) {
			this.$store.dispatch('users/assignUserMentors', {
				userOrganisationId: this.userOrganisationId,
				users: Array.isArray(user) ? user : [user],
			});
			
			this.$emit('storeUpdated', {valid:true});
		},
		unassignUsers(user) {
			this.$store.dispatch('users/unassignUserMentors', {
				userOrganisationId: this.userOrganisationId,
				users: Array.isArray(user) ? user : [user],
			});
			
			this.$emit('storeUpdated', {valid:true});
		},
	},
}
</script>

<style lang="scss">
#assignment {}
</style>
